import React, { useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import { Link } from "react-router-dom";
import { TableCell, TableRow, Switch, TextField, Collapse, Box, Button } from "@material-ui/core";
import { addFolderInType } from "./../../redux/actions/typeAction"
import { typeAPI } from "../../services/TypeAPI";
import Swal from "sweetalert2"
import Path from "../Row/path"

const Row = (props) => {
    const { res, UpdateStatus, setOpen, setDir, setPath } = props;
    const { userData } = useSelector(state => state.user)
    const dispatch = useDispatch()
    const [open, setOpen2] = useState(false)
    const [del, setDel] = useState(0)

    const AddFolder = (dir) => {
        Swal.fire({
            customClass: {
                popup: 'swalemailwidth'
            },
            title: "โปรดป้อนชื่อโฟลเดอร์ของคุณ",
            input: "text",
            inputAttributes: {
                autocapitalize: "off"
            },
            confirmButtonColor: "#6ab23a",
            showCancelButton: true,
            confirmButtonText: "เรียบร้อย",
            showLoaderOnConfirm: true,
            preConfirm: (folder) => {
                try {
                    if (!folder) throw { message: "โปรดป้อนชื่อโฟลเดอร์ของคุณ" }
                    return typeAPI.addFolderInType({ dir, name: folder })
                        .then((response) => {
                            if (response.status != 200) {
                                throw new Error(response.message);
                            }
                        })
                        .catch(error => {
                            Swal.showValidationMessage(error.message);
                        })

                } catch (error) {
                    Swal.showValidationMessage(error.message);
                }
            },
            allowOutsideClick: () => !Swal.isLoading()
        }).then((resuilt) => {
            dispatch(addFolderInType({ name: resuilt.value, dir }));
        })
    }

    const ModalChange = ({ dir, path }) => {
        setOpen(true)
        setDir(dir)
        setPath(path)
    }

    return (
        <React.Fragment>
            <TableRow style={{ backgroundColor: 'transparent' }}>
                <TableCell style={{ textAlign: 'center', color: 'black', fontSize: '16px', fontWeight: 300 }}>{res.name}</TableCell>
                <TableCell style={{ textAlign: 'center', color: 'black', fontSize: '16px', fontWeight: 300 }}>{res.dir}</TableCell>
                <TableCell style={{ textAlign: 'center', color: 'black', fontSize: '16px', fontWeight: 300 }}><Switch onClick={() => UpdateStatus(res)} checked={res.status} disabled={!userData?.permission?.edit_type} style={{ color: res.status ? '#6ab23a' : '#6C757D', cursor: 'pointer' }} /></TableCell>
                {userData?.permission?.edit_type && <TableCell style={{ textAlign: 'center', color: 'black', fontSize: '16px', fontWeight: 300 }}>
                    <Link style={{ textDecoration: 'none' }} to={`edit-type/${res._id}`}>
                        <Button
                            type="submit"
                            variant="contained"
                            style={{
                                border: "2px solid transparent",
                                backgroundColor: 'transparent',
                                borderRadius: "10px",
                                color: "#6C757D",
                                fontSize: "14px",
                                textDecoration: "none",
                                textTransform: "none",
                                boxShadow: 'none',
                            }}
                        >
                            <span style={{ textDecoration: 'underline', fontWeight: 'bold' }}>แก้ไข</span>  <i style={{}} className=''></i>
                        </Button></Link></TableCell>}
                {userData?.permission?.manage_file && <TableCell style={{ textAlign: 'center', color: 'black', fontSize: '16px', fontWeight: 300 }}>
                    <span style={{ textDecoration: 'underline', fontWeight: 'bold', cursor: 'pointer' }} onClick={() => setOpen2((old) => !old)}>
                        ดูเพิ่มเติม</span> </TableCell>}
            </TableRow>
            <TableRow>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box sx={{ margin: 1 }}>
                            <div className="zoning_am-container">
                                <Button onClick={() => AddFolder(res.dir)} style={{ marginLeft: '10px', color: 'white', backgroundColor: 'black', textTransform: 'none' }} >สร้าง Folder</Button>
                                {Array.isArray(res.path) && res.path.map((rex, mdex) => (rex.name && <div style={{ margin: 'auto', marginTop: '10px', width: '90%', border: '1px solid lightgrey', borderRadius: '8px', padding: '10px' }} key={mdex}>
                                    <div style={{ padding: '5px', fontSize: '24px', display: 'flex' }}>
                                        Folder : {rex.name} จำนวน {Array.isArray(rex.list) && rex.list.length - del} ไฟล์</div>
                                    <div>
                                        <div>
                                            <Button style={{ marginLeft: '10px', fontWeight: 600, border: '1px solid lightgray', borderRadius: '4px' }} onClick={() => ModalChange({ dir: res.dir, path: rex.name })}>เพิ่มไฟล์</Button>
                                        </div>
                                    </div>
                                    <Path list={rex.list} dir={res.dir} path={rex.name} setDel={setDel} />
                                </div>))}
                            </div>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </React.Fragment>
    )
}

export default Row